var map = {
	"./frame-creative.png": 1986,
	"./frame-img.png": 1987,
	"./frame-math.png": 1988,
	"./frame-pyt-nosnake.png": 1989,
	"./frame-pyt.png": 1990,
	"./frame.svg": 1991,
	"./start-bg.png": 1633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1985;